import { __rest, __assign } from '../../external/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef } from 'react';
import styles from './Card.module.scss.js';

var Title = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style;
    return (jsx("h2", __assign({ className: clsx(styles.title, className), style: style }, { children: children })));
};
var Separator = function (_a) {
    var _b;
    var className = _a.className, style = _a.style, isFullWidth = _a.isFullWidth;
    return (jsx("div", { style: style, className: clsx(styles.separator, (_b = {}, _b[styles.separatorFullWidth] = isFullWidth, _b), className) }));
};
var Footer = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style, _b = _a.as, Tag = _b === void 0 ? 'div' : _b;
    return (jsx(Tag, __assign({ className: clsx(styles.footer, className), style: style }, { children: children })));
};
var CardComponent = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, _b = _a.as, Tag = _b === void 0 ? 'div' : _b, props = __rest(_a, ["children", "className", "as"]);
    return (jsx(Tag, __assign({}, props, { ref: ref, className: clsx(styles.card, className) }, { children: children })));
});
var Card = CardComponent;
Card.Title = Title;
Card.Separator = Separator;
Card.Footer = Footer;

export { Card, CardComponent };
